import { render } from "./NotFound.vue?vue&type=template&id=64a601c2"
const script = {}

import exportComponent from "/data/home/geraldo/git/Intmain/lowcarb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__